import api from "./http";

const API_URL = "/api/backup-types";

export async function getBackupTypes() {
    try {
        const res = await api.get(API_URL);
        return Array.isArray(res.data?.data) ? res.data.data : [];
    } catch (error) {
        console.error("Error fetching backup types:", error);
        return [];
    }
}

export async function createBackupType(data) {
    const res = await api.post(API_URL, data);
    return res.data?.data || res.data;
}

export async function updateBackupType(id, data) {
    const res = await api.put(`${API_URL}/${id}`, data);
    return res.data?.data || res.data;
}

export async function deleteBackupType(id) {
    await api.delete(`${API_URL}/${id}`);
}
